import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'

import LocalPickerPick from 'components/picker/pick/local/local_picker_pick'
import DrivePickerPick from 'components/picker/pick/drive/drive_picker_pick'
import DropboxPickerPick from 'components/picker/pick/dropbox/dropbox_picker_pick'
import OnedrivePickerPick from 'components/picker/pick/onedrive/onedrive_picker_pick'
import { localize } from 'helpers/translator'

import styles from './nearpod_picker_options.scss'

const LocalIconSvg = () => <svg height="34" width="31" viewBox="0 0 31 34"> <g fill="#00A8FF"> <rect height="23.967" width="3.321" rx="1.661" x="13.839" y=".792"/> <rect height="13.377" width="3.321" rx="1.661" x=".066" y="20.336"/> <rect height="13.377" width="3.321" rx="1.661" x="27.613" y="20.336"/> <path d="M29.434 30.392v3.32H1.564v-3.32z"/> <rect height="13.484" width="3.321" rx="1.661" transform="rotate(-45 19.195 6.034)" x="17.534" y="-.708"/> <rect height="13.484" width="3.321" rx="1.661" transform="rotate(45 11.998 6.034)" x="10.338" y="-.708"/> </g> </svg>
const DriveIconSvg = () => <svg height="36" width="41" viewBox="0 0 41 36"> <path d="M13.22.77L.25 23l6.59 11.57L19.9 12.4 13.22.77" fill="#00a661"/> <path d="M14.21 23.78L8.16 34.06l-.56.95h26.27l6.58-11.23H14.21" fill="#067ee4"/> <path d="M20.9 12.38l6.05 10.53h13.51L27.6.34H13.98l6.92 12.04" fill="#ffcc5f"/> </svg>
const DropboxIconSvg = () => <svg height="36" width="40" viewBox="0 0 40 36"> <path d="M31 26.5c-.06-.03-.13-.03-.19.01l-3.06 2.26-7.63-6.45c-.07-.06-.17-.06-.24 0l-7.64 6.45-3.29-2.27c-.06-.03-.13-.03-.19 0s-.1.09-.1.16v2.25c0 .07.04.13.1.16l11.14 6.69c.03.02.07.02.1.02s.07 0 .1-.02l10.91-6.69c.05-.03.09-.09.09-.16v-2.25c0-.07-.04-.13-.1-.16" fill="#027ee7"/> <path d="M39.02 7.93c.05-.03.08-.09.07-.15 0-.06-.03-.12-.08-.15L27.96.38c-.07-.05-.16-.04-.22.01l-7.76 6.55-7.7-6.55c-.07-.05-.16-.06-.23-.01L.99 7.63c-.05.03-.08.09-.08.15-.01.06.02.12.07.15l7.76 6.05.02.01h-.01L.98 19.92c-.05.03-.08.09-.07.15 0 .06.03.12.08.15l11.25 7.26c.03.02.07.03.1.03.04 0 .09-.02.12-.05L20 21.08c.01-.01.02-.02.02-.03l7.6 6.41c.03.03.07.05.12.05.03 0 .07-.01.1-.03l10.98-7.2c.05-.03.08-.08.08-.14.01-.06-.02-.12-.07-.16L31.21 14s-.01-.01-.02-.01l.02-.01 7.81-6.05zM20 20.8l-.02-.02-11.03-6.79 11.03-6.73L31 13.99l-10.95 6.76c-.02.01-.04.03-.05.05zm0 0" fill="#027ee7"/> </svg>
const OnedriveIconSvg = () => <svg height="25" id="Capa_1" width="43" viewBox="0 0 43.5 25.7"> <path fill="#0066AC" d="M39.4 16.3v-.4c0-3.5-2.9-6.3-6.3-6.3-1.2 0-2.4.4-3.5 1-1.2-2.2-3.7-3.9-6.3-3.9-3.9 0-7.1 3.3-7.1 7.1v.4h-.4c-3.3 0-5.7 2.7-5.7 5.7s2.7 5.7 5.7 5.7h24.7c.2 0 .2-.2.4-.2 1.6-.8 2.7-2.4 2.7-4.5.1-2.1-1.8-4.2-4.2-4.6z"/> <path fill="#0066AC" d="M14.9 13.1c.4-4.3 4.1-7.8 8.4-7.8 2.7 0 5.3 1.2 6.9 3.5 1-.4 2-.6 3.1-.6h.2C32.9 3.7 29 0 24.1 0c-3.7 0-6.7 2-8.4 5.1-1-.6-2.2-1-3.7-1-3.7 0-6.7 3.1-6.7 6.7 0 .4 0 1 .2 1.4-3.1.3-5.5 2.9-5.5 6 0 3.3 2.7 5.9 5.9 5.9h3.9c-.8-1.2-1.2-2.4-1.2-3.9 0-3.7 2.8-6.7 6.3-7.1z"/> </svg>

class NearpodPickerOptions extends PureComponent {
	render() {
		return (
			<div styleName='source-options'>
				<p styleName='source-options-choose'>{localize('picker_options_title')}</p>
				<ul styleName='source-options-list'>

					<li styleName='source-options-list-item'>
						<LocalPickerPick
							onChange={this.props.onFilesPicked}
							onFileError={this.props.onFileError}
							multiselect={this.props.multiselect}
							accept={this.props.accept}
						>
							<LocalIconSvg />
						</LocalPickerPick>
					</li>

					<li styleName='source-options-list-item'>
						<DrivePickerPick
							onChange={this.props.onFilesPicked}
							multiselect={this.props.multiselect}
							accept={this.props.accept}
							googleDrivePickerOrigin={this.props.googleDrivePickerOrigin}
						>
							<button styleName='source-options-button'>
								<DriveIconSvg />
							</button>
						</DrivePickerPick>
					</li>

					<li styleName='source-options-list-item'>
						<DropboxPickerPick onChange={this.props.onFilesPicked} multiselect={this.props.multiselect} accept={this.props.accept}>
							<button styleName='source-options-button'>
								<DropboxIconSvg />
							</button>
						</DropboxPickerPick>
					</li>

					<li styleName='source-options-list-item'>
						<OnedrivePickerPick onChange={this.props.onFilesPicked} multiselect={this.props.multiselect} accept={this.props.accept}>
							<OnedriveIconSvg />
						</OnedrivePickerPick>
					</li>

				</ul>
			</div>
		)
	}
}

export default CSSModules(NearpodPickerOptions, styles, {allowMultiple: true})
